import React from 'react';
import { FieldTreeService } from '../../../services/FieldTrees';
import { REQUEST_PARAMS } from '../../../utilities/constants';
import DropdownSelector from '../../dropdowns/DropdownSelector';
import SessionStorageService from '../../../services/utilities/SessionStorageService';

/**
 * 現場に設定された協力会社の複数選択 ドロップダウン
 * @param selectedValues {array} 初期値
 * @param onSelect {func} 選択処理時のcallback処理
 * @param exceptionAllLoadedLimit {boolean} 協力会社20件(limit_by_first_companies)時に使用されていた設定を使用するか
 */
export const FieldTreeOperatableIdsDropdown = ({
  selectedValues,
  label = '未選択',
  onSelect,
  clearFlag,
  isWholeSource = false,
  exceptionAllLoadedLimit = false,
  isShowFinished = false,
  isShowNoForeman = false,
}) => (
  <DropdownSelector
    className='form-element__element'
    label={label}
    multiple={true}
    selectorName='field_tree_id'
    api={params =>
      FieldTreeService.selectableCompaniesList(
        SessionStorageService.getFieldId(),
        params
      )
    }
    limit={REQUEST_PARAMS.parentLimit}
    apiParams={{
      limit: REQUEST_PARAMS.parentLimit,
      field_id: SessionStorageService.getFieldId(),
      whole_source: isWholeSource ? 1 : undefined,
      show_finished: isShowFinished ? 1 : undefined,
      show_no_foreman: isShowNoForeman ? 1 : undefined,
    }}
    apiSearchKey='name'
    selectedValues={selectedValues}
    keyName='name'
    valueName='field_tree_id'
    apiBindDataKey={'companies'}
    onSelect={onSelect}
    widthClass='dropdown__item--wide'
    clearFlag={clearFlag}
    exceptionAllLoadedLimit={exceptionAllLoadedLimit}
  />
);



// WEBPACK FOOTER //
// ./src/components/dropdowns/multi/FieldTreeOperatableIds.jsx